// src/components/home/WhatsNew.jsx
import React from "react";
import { FaBolt, FaBrain, FaChartBar, FaLock, FaPaintBrush, FaRocket } from "react-icons/fa";
import "./WhatsNew.css";

const whatsNewItems = [
  {
    icon: <FaBolt style={{ color: "#f59e0b" }} />,
    title: "Faster Performance",
    desc: "Optimized React 19 engine delivering lightning-fast test loads and instant evaluation feedback.",
  },
  {
    icon: <FaBrain style={{ color: "#a855f7" }} />,
    title: "Smarter AI",
    desc: "Upgraded AI quiz generator creating high-yield, topic-specific aptitude and technical questions.",
  },
  {
    icon: <FaChartBar style={{ color: "#3b82f6" }} />,
    title: "Better Analytics",
    desc: "Comprehensive growth dashboards with accuracy breakdown, speed metrics, and topic weakness insights.",
  },
  {
    icon: <FaLock style={{ color: "#10b981" }} />,
    title: "Improved Authentication",
    desc: "One-time exam access tokens, instant security logs, and seamless Firebase role-based permissions.",
  },
  {
    icon: <FaPaintBrush style={{ color: "#ec4899" }} />,
    title: "Better UI/UX",
    desc: "Refined glassmorphism themes, high contrast accessibility mode, and smooth motion interactions.",
  },
  {
    icon: <FaRocket style={{ color: "#06b6d4" }} />,
    title: "Multiple Optimizations",
    desc: "Reduced memory usage, offline security monitor, and enhanced Monaco code compiler environment.",
  },
];

const WhatsNew = () => {
  return (
    <section className="bvh-whats-new-section">
      <div className="bvh-whats-new-header" data-aos="fade-up">
        <span className="bvh-whats-new-badge">✨ What's New</span>
        <h2 className="bvh-whats-new-title">
          What's New in <span>V2 Beta</span>
        </h2>
        <p className="bvh-whats-new-subtitle">
          Built to elevate your practice experience with cutting-edge speed, intelligence, and design.
        </p>
      </div>

      <div className="bvh-whats-new-grid">
        {whatsNewItems.map((item, index) => (
          <div
            className="bvh-whats-new-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="bvh-whats-new-icon">{item.icon}</div>
            <h3 className="bvh-whats-new-card-title">{item.title}</h3>
            <p className="bvh-whats-new-card-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default React.memo(WhatsNew);
